import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { default as BSOffcanvas} from 'bootstrap/js/dist/offcanvas';

/***
 Класс offcanvas

 @example
 Аттрибуты:
 data-parent {string, default = ''} - селектор родителя канваса, куда будет навешан класс при открытии
 аттрибуты библиотеки: https://getbootstrap.com/docs/5.2/components/offcanvas/#options
 */
class Offcanvas {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент с классом offcanvas
   */
  constructor(elem) {
    this.BlockError = new BlockError({ blockName: 'Offcanvas', destroy: this.destroy });
    if (!elem) return this.BlockError.error('Отсутствует elem');

    this.block = elem;
    this.block.Offcanvas = this;
    this.init();
  }

  init = () => {
    this.parentSelector = this.block.dataset.parent;
    if (!this.parentSelector) return;

    this.parent = document.querySelector(this.parentSelector);
    if (!this.parentSelector) return this.BlockError.error(`Отсутствует ${this.parentSelector}`);

    this.block.addEventListener('show.bs.offcanvas', this.offcanvasOpen);
    this.block.addEventListener('hide.bs.offcanvas', this.offcanvasClose);

    this.block.classList.add('offcanvas_inited');
  };

  offcanvasOpen = () => {
    this.parent.classList.add('offcanvas-show');
  };

  offcanvasClose = () => {
    this.parent.classList.remove('offcanvas-show');
  };

  destroy = () => {
    if (this.block) {
      this.block.classList.remove('offcanvas_inited');
      this.block.removeEventListener('show.bs.offcanvas', this.offcanvasOpen);
      this.block.removeEventListener('hide.bs.offcanvas', this.offcanvasClose);
      delete this.block.Offcanvas;
    }
  };

  static init() {
    Array.from(document.querySelectorAll('div:is(.offcanvas, .offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl):not(.offcanvas_inited)')).forEach((elem) => new Offcanvas(elem));
  }
}

document.addEventListener('DOMContentLoaded', Offcanvas.init);

// Экспорт;
window.Block.Offcanvas = Offcanvas;

// Класс tooltip от bootstrap
window.bootstrap.Offcanvas = BSOffcanvas;
